import styled from 'styled-components';

export const Container = styled.div`
  span {
    max-width: unset;
  }
`;